var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-primary tab-header" },
    [
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "b-row",
            {
              staticClass: "p-3 d-flex align-items-center flex-container",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("b-col", { attrs: { md: "6" } }, [
                _c("h5", { staticClass: "bg-primary p-3 my-auto" }, [
                  _vm._v(" " + _vm._s(_vm.title) + " ")
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c(
                    "b-row",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "flex-end"
                      }
                    },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "col",
                          staticStyle: { "z-index": "100" },
                          attrs: { md: "6" }
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                ref: "searchInput",
                                staticClass: "search-text",
                                attrs: {
                                  placeholder: _vm.$t("WORKFLOW.SEARCH")
                                },
                                on: { input: _vm.emitInput }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showClear,
                                    expression: "showClear"
                                  }
                                ],
                                staticClass: "clear-btn",
                                domProps: { innerHTML: _vm._s(_vm.svg.broom) },
                                on: { click: _vm.clearFilter }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "col",
                          staticStyle: { "z-index": "100" },
                          attrs: { md: "6" }
                        },
                        [
                          _c("multiselect", {
                            staticClass: "custom-multiselect",
                            attrs: {
                              options: _vm.editedOptions,
                              "track-by": "title",
                              label: "title",
                              value: _vm.editedByValue,
                              "close-on-select": true,
                              "custom-label": _vm.customLabel,
                              "show-labels": false,
                              "preselect-first": true,
                              placeholder: "Edited By",
                              multiple: true
                            },
                            on: {
                              remove: function($event) {
                                _vm.optionRemoved($event)
                              },
                              select: function($event) {
                                _vm.optionAdded($event)
                              }
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "option",
                                fn: function(props) {
                                  return [
                                    _c("div", { staticClass: "option__desc" }, [
                                      _c("div", { staticClass: "avatar" }, [
                                        _vm._v(_vm._s(props.option.title[0]))
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          checked: _vm.isSelected(
                                            props.option.title
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "option__title" },
                                        [_vm._v(_vm._s(props.option.title))]
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f4529b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f4529b0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/FeaturesSearchBar.vue
// module id = 1282
// module chunks = 2